import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function AjusteLogin() {
  const [cpf, setCpf] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setCarregando(true);
    setErro(null);

    const nascimentoFormatado = dataNascimento.split("-").reverse().join("");

    try {
      const resp = await fetch("http://192.168.100.196:8001/ajuste/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cpf, nascimento: nascimentoFormatado }),
      });

      if (!resp.ok) {
        const err = await resp.json();
        throw new Error(err.detail || "Erro na validação.");
      }

      const data = await resp.json();
      navigate(`/ajuste/dados/${data.pessoas[0].id}`, { state: data });

    } catch (err) {
      setErro(err.message || "Erro ao validar dados.");
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div style={{
      backgroundColor: "#f3f4f6",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 20
    }}>
      <div style={{
        background: "#fff",
        padding: 30,
        borderRadius: 12,
        boxShadow: "0 0 12px rgba(0,0,0,0.1)",
        width: "100%",
        maxWidth: 420
      }}>
        <h2 style={{ marginBottom: 20, color: "#333", textAlign: "center" }}>Ajuste de Proposta</h2>

        <label style={{ fontWeight: 500 }}>CPF</label>
        <input
          type="text"
          value={cpf}
          onChange={e => setCpf(e.target.value)}
          placeholder="000.000.000-00"
          style={{
            width: "100%",
            padding: "10px 14px",
            marginBottom: 14,
            borderRadius: 8,
            border: "1px solid #ccc",
            outlineColor: "#00a99d"
          }}
        />

        <label style={{ fontWeight: 500 }}>Data de Nascimento</label>
        <input
          type="date"
          value={dataNascimento}
          onChange={e => setDataNascimento(e.target.value)}
          style={{
            width: "100%",
            padding: "10px 14px",
            marginBottom: 14,
            borderRadius: 8,
            border: "1px solid #ccc",
            outlineColor: "#00a99d"
          }}
        />

        {erro && (
          <div style={{
            backgroundColor: "#f8d7da",
            color: "#721c24",
            padding: 10,
            marginBottom: 14,
            borderRadius: 8,
            fontSize: 14
          }}>
            {erro}
          </div>
        )}

        <button
          onClick={handleLogin}
          disabled={carregando}
          style={{
            width: "100%",
            padding: "12px 20px",
            backgroundColor: carregando ? "#9cd7d1" : "#00a99d",
            color: "white",
            border: "none",
            borderRadius: 8,
            fontSize: 16,
            cursor: carregando ? "not-allowed" : "pointer",
            transition: "background-color 0.2s"
          }}
        >
          {carregando ? "Validando..." : "Acessar"}
        </button>
      </div>
    </div>
  );
}

export default AjusteLogin;
